import { AxiosResponse } from 'axios';
import { IntegrationInterfaceCompanyRequest } from '@/main/models/request';
import { IntegrationInterfaceCompanyResponse } from '@/main/models/response';
import { PaginationResponse } from '@/main/models/common/paginationResponse';

export abstract class IIntegrationInterfaceCompanyApi {
  abstract getSearchGrid(
    request: IntegrationInterfaceCompanyRequest
  ): Promise<
    AxiosResponse<PaginationResponse<IntegrationInterfaceCompanyResponse[]>>
  >;
}

